// extracted by mini-css-extract-plugin
module.exports = {"horizontalScrollingItems":"CheapestDestinations_horizontalScrollingItems___bZRY","horizontalScrollingItem":"CheapestDestinations_horizontalScrollingItem__fQrQ7"};